export default {
    emits: ["click-outside", "edit", "delete", "open", "close", "remove", "select", "disable", "sync"],
    data: () => ({
        readonly_status: false,
        busy_status: false,
        temporaries_uid: {},
        api_abort_controllers: {},
        pending_methods: {},
        open_list: [],
        reload_data_index: 0,
        // Components initialization
        component_initialization: {
            actions: [],
            status: {},
            current: null,
            error: {},
        },
        modals: {
            read: false,
            create: false,
            update: false,
            delete: false,
            custom: false,
            action: false,
        }
    }),
    computed: {
        // Components initialization
        isComponentReady(){
            return Object.values(this.component_initialization.status).every(v => v === "ready");
        },
        isComponentInError(){
            return Object.values(this.component_initialization.status).some(v => v === "error");
        },
    },
    props: {
        reload_data: { type: [Object, Array, Number], default: 0 },
        busy: { type: Boolean, },
        readonly: { type: Boolean, },
        editable: { type: Boolean, },
        manage: { type: Boolean, },
        mode_manage: { type: String, default: "read"},
        legitimate: { type: Boolean, },
        draggable: { type: Boolean, },
    },
    methods: {
        go_to_home(){
            this.$router.push({ name: 'group-detail', params: { groupUid: this.$route.params.groupUid } });
        },
        get_temporary_uid(name){
            if(!this.temporaries_uid[name])
                this.temporaries_uid[name] = Math.random().toString(16).slice(2);
            return this.temporaries_uid[name];
        },
        put_on_hold(callback, timer=1000, name="waitlocally"){
            let uid = this.get_temporary_uid(name);
            if(this.pending_methods[uid])
                clearTimeout(this.pending_methods[uid]);
            this.pending_methods[uid] = setTimeout(() => {
                console.log("Pending method executed", uid);
                if(callback) callback();
            }, timer);
        },

        // Open list
        is_open(id, callback){
            if(this.open_list.includes(id)){
                if(callback) callback();
                return true;
            }
        },
        open_or_close(id, callback){
            const pos = this.open_list.indexOf(id);
            let opened;
            if(pos === -1){
                opened = true;
                this.open_list.push(id);
            }else{
                opened = false;
                this.open_list.splice(pos, 1);
            }
            if(callback) callback(opened);
        },

        // Api
        urlApi(suffix, bypass=false){
            let base_url = "/api/";
            let groupid = this.$route.params.groupUid || this.$route.params.groupNamedId;
            if(bypass || !groupid)
                return base_url + suffix;
            return base_url + groupid + "/" + suffix;
        },
        url_api(suffix, bypass=false){
            let base_url = "/api/";
            let groupid = this.$route.params.groupUid || this.$route.params.groupNamedId;
            if(bypass || !groupid)
                return base_url + suffix;
            return base_url + groupid + "/" + suffix;
        },
        url_api_form(suffix, form, bypass=false){ return this.urlApi(suffix, bypass) + "forms/" + form + "/"; },
        url_api_reporting_list(suffix, format, bypass=false){ return this.urlApi(suffix, bypass) + "reporting_list/"; },
        call_api_data({ url, method, payload, cancelid, timeout }){
            payload = payload || {};
            // Abort signal
            if(cancelid){
                if(this.api_abort_controllers[cancelid])
                    this.api_abort_controllers[cancelid].abort();
                this.api_abort_controllers[cancelid] = new AbortController();
                payload.signal = this.api_abort_controllers[cancelid].signal;
            }else if(timeout){
                payload.signal = new AbortController().timeout = timeout;
            }
            // Return the promise
            return this.$api[method || "get"](this.urlApi(url), payload);
        },

        options_to_form(options){
            return Object.entries(options).map(([key, props]) => ({
                ...props,
                input: props.type,
                name: key
            }));
        },

        // Generics
        arrayToObjectKeys(arr, def=false){
            return arr.reduce((acc, val) => { return {...acc, [val]: def}; }, {});
        },
        emitClickOutside($event){
            this.$emit("click-outside", $event);
        },
        propOrForce(name){
            return (this[name] || this[name+"_force"]);
        },

        // Components initialization
        setComponentActionStatus(action, status="ready"){
            this.component_initialization.status[action] = status;
        },
        setComponentActionError(action, error){
            this.component_initialization.status[action] = "error";
            this.component_initialization.error[action] = error;
        },
        async initializeComponent(action_list){
            this.component_initialization.actions = action_list;
            this.component_initialization.status = this.arrayToObjectKeys(action_list, "await");
            for(var t in action_list){
                console.log(action_list[t], this.isComponentReady, this.component_initialization);
                this.component_initialization.current = action_list[t];
                await this[action_list[t]]();
                console.log(action_list[t], this.isComponentReady, this.component_initialization);
            }
        },

        // import external libraries
        loadScriptJS(url, id){
            return new Promise((resolve, reject) => {
                if (document.getElementById(id)) {
                    resolve();
                    return;
                }

                const script = document.createElement('script');
                script.src = url;
                script.id = id;
                script.async = true;
                script.onload = () => resolve();
                script.onerror = () => reject(new Error(`Échec du chargement du script ${url}`));
                document.head.appendChild(script);
            });
        },
        loadChainScriptJS(urls, prefix){
            // Charger les scripts séquentiellement
            return urls.reduce((promise, url, index) => {
                return promise.then(() => this.loadScriptJS(url, prefix + index));
            }, Promise.resolve());
        },
        loadScriptCSS(url){
            return new Promise((resolve, reject) => {
                // Vérifiez si le CSS avec la même URL est déjà présent
                const links = Array.from(document.getElementsByTagName('link'));
                const cssExists = links.some(link => link.href === url);
                if (cssExists) {
                  resolve(); // Si le CSS existe déjà, on résout immédiatement la promesse
                  return;
                }

                const link = document.createElement('link');
                link.href = url;
                link.rel = 'stylesheet';
                link.onload = () => resolve();
                link.onerror = () => reject(new Error(`Échec du chargement du CSS ${url}`));
                document.head.appendChild(link);
            });
        },
        loadChainScriptCSS(urls){
            // Charger les scripts séquentiellement
            return urls.reduce((promise, url) => {
                return promise.then(() => this.loadScriptCSS(url));
            }, Promise.resolve());
        },

        has_authorization_service(app){
            if(this.$is_staff || this.$is_admin)
                return true;
            const level = this.currentGroup["show_"+app];
            if(level && this.currentGroup["enable_"+app]){
                if (level == "MANAGER")
                    return this.$is_manager;
                return (level == "INVOLVED" || level == "USER");
            }
            return false;
        },
    },
}
